import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import { AppBar, Toolbar, Button, Menu, MenuItem } from '@material-ui/core';
import './appbar.css';

@inject('authStore', 'viewStore')
@withRouter
@observer
class StayMenuAppBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            loadingMessage: 'Loading...',
            anchorEl: null,
        }
    }

    showLoading = (message) => {
        this.setState({
            isLoading: true,
            loadingMessage: message
        })
    }

    handleSignOut = () => {
        this.props.authStore.removeAdminInfo();
        this.props.history.push('/admin/login');
    }

    handleMenuOpen = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    }

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
    }

    handleNavigateToSystem = (url) => {
        const token = window.localStorage.getItem('adminLoginToken')?.replace(/['"]+/g, '');
        if (token) {
            window.open(`${url}/admin/login/${token}`, '_blank');
        }
        this.handleMenuClose();
    }

    render() {
        const { title } = this.props;
        const { anchorEl } = this.state;
        const token = window.localStorage.getItem('adminLoginToken')?.replace(/['"]+/g, '');

        return (
            <AppBar
                position='fixed'
                classes={
                    {
                        root: 'app-bar'
                    }
                }
            >
                <Toolbar>
                    <div className='app-title-container'>
                        <span className='app-title'>
                            {title}
                        </span>
                    </div>
                    <div
                        style={{
                            paddingRight: 8
                        }}
                    >
                        <span style={{ color: '#3D3935' }}>Hi, {window.localStorage.getItem('adminLoginName').replace(/['"]+/g, '')}</span>
                    </div>
                    {token && (
                        <div style={{ marginRight: 8 }}>
                            <Button 
                                color='primary' 
                                variant='outlined'
                                onClick={this.handleMenuOpen}
                            >
                                Switch Outlet
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={this.handleMenuClose}
                            >
                                <MenuItem onClick={() => this.handleNavigateToSystem('https://cksprincessterrace.staypls.com')}>
                                    CKS Princess Terrace
                                </MenuItem>
                            </Menu>
                        </div>
                    )}
                    <div style={{ width: 100 }}>
                        <Button color='primary' onClick={this.handleSignOut}>
                            Sign Out
                        </Button>
                    </div>
                </Toolbar>
            </AppBar>
        )
    }
}

export default StayMenuAppBar;